export enum DataHooks {
  WeeklyTimeSlotsLayout = 'deprecated-weekly-time-slots-layout',
  Timezone = 'timezone',
}
